import React from 'react';

import { useGetImmunization } from '@hooks/api/immunization';
import { useCuration } from '@hooks/useCuration';
import { useSession } from '@hooks/useSession';

import DrilldownContent from './Content';

const Immunization: React.FC<{ id?: string }> = ({ id = '' }) => {
  const {
    state: { activeProfile, isCurator },
  } = useSession();
  const {
    state: { isCreating, isEditing },
    finishAddingRecord,
    stopEditingRecord,
  } = useCuration();

  const [patient_id] = [activeProfile?.patient_id];

  const { data, loading } = useGetImmunization({
    record_id: id,
  });

  function handleSubmit() {
    stopEditingRecord();
    finishAddingRecord();
  }

  return (
    <DrilldownContent
      data={data}
      isCreating={isCreating}
      isCurator={isCurator}
      isEditing={isEditing}
      loading={loading}
      onSubmit={handleSubmit}
      patientId={patient_id}
    />
  );
};

export default Immunization;
